module.exports = __webpack_public_path__ + "static/media/alarm-icon.31c86e2b.svg";